export type PageChangeHandler = (x: number, immediately?: boolean) => void;

export enum JobStatus {
  all = 'All',
  approved = 'Approved',
  denied = 'Denied',
  errorLoad = 'Error Load',
  pending = 'Pending',
  received = 'Recieved',
  completed = 'Completed',
  processingTransform = 'Processing',
  allComplete = 'Done',
  recieved = 'Recieved',
  processingBenefitSponsors = 'Processing Benefit Sponsors',
  processingGroups = 'Processing Groups',
  processingProducts = 'Processing Products',
  processingContacts = 'Processing Contacts',
  processingExternalGroupRelations = 'Processing AGR/EGR',
  cancelled = 'Cancelled',
  allCompleted = 'All Completed',
  salesForceSyncError = 'Sales Force Sync Error',
  salesForceSyncCompleteWithErrors = 'Sales Force Sync Complete With Errors',
  salesForceSyncComplete = 'Sales Force Sync Complete',
  salesForceSyncReattempt = 'Sales Force Sync Reattempt',
  salesForceSyncInProgress = 'Sales Force Sync In Progress',
  salesForceSyncPreparing = 'Sales Force Sync Preparing',
  processingReports = 'Processing Reports',
  PreloadingExternalGroupRelations = 'Preloading External Group Relations',
  preloadingGroups = 'Preloading Groups',
  preloadingBenefitSponsors = 'Preloading Benefit Sponsors',
  deferred = 'Waiting For Other Job',
  automaticallyApproved = 'Automatically Approved',
  errorTransform = 'Error Transform',
  errorExtract = 'Error Extract',
  completedExtract = 'Completed Extract',
  processingExtract = 'Processing Extract',
  processingLoad = 'Processing Load',
  completedLoad = 'Completed Load',
  preloadingRTE = 'Preloading RTE',
  processingRTE = 'Processing RTE',
  stopped = 'Stopped'
}

type ErrorDetail = {
  message: string;
  meta?: {
    stack: string;
  };
};

type JobError = {
  [key: string]: ErrorDetail[];
};

type StatDetail = {
  [key: string]: number;
};

type JobStats = {
  [key: string]: {
    [subKey: string]: StatDetail;
  };
};

export type Job = {
  ApprovedBy: string;
  AuditId: string;
  Client: string;
  CreatedAt: string;
  UpdatedAt: string;
  CsvFiles: string[];
  Error: JobError;
  Stats: JobStats;
  Status: keyof typeof JobStatus;
  Template: string;
  ZipFileName: string;
};
